<div class="feedContainer" [ngClass]="{'collaspe':showFeedCon == false}" #feedContainer appSameHeight className="sameHeight">
  <div class="header">
    <div class="text" *ngIf="!showFeedCon" (click)="clickOnFeedContainer()" >
      <div class="leftSection" ><i class="fas fa-chevron-down"></i>&nbsp;</div>
      <span class="feedSlideCon collapsed headText">Fantasy Feed</span>
    </div>

    <div class="text" *ngIf="showFeedCon && pageName != 'lgProfile'">      
      <div  *ngIf="!isMobile" (click)="!isMobile?clickOnFeedContainer():'javascript:void(0)'" class="leftSection"><i class="fas fa-chevron-up"></i>&nbsp;</div>
      <span (click)="!isMobile?clickOnFeedContainer():'javascript:void(0)'"  class="headText feedSlideCon">Fantasy Feed</span>      
      <div class="rightSection">
        <!--i class="fas fa-plus create2" [ngClass]="{'active':showPostbox}" matTooltip="Create A Post"
          matTooltipPosition="below" (click)="showPostbox = true;postboxType = 'post';postboxPost = null;"></i-->
        <i class="fas fa-sliders-h settings2" [ngClass]="{'active':showFilters}" matTooltip="Feed Settings"
          matTooltipPosition="below" (click)="showFilters = !showFilters"></i>
        <i class="fas fa-search search2" [ngClass]="{'active':showFeedSearch}" matTooltip="Search Feed"
          matTooltipPosition="below" (click)="showFeedSearch = !showFeedSearch"></i>
        <!-- <i [ngClass]="{'fa-expand': !expanded, 'fa-compress': expanded}" class="fas expand" [matTooltip]="((!expanded)?'Expand':'Condense')+' Feed'" matTooltipPosition="below"></i> -->
      </div>
    </div>
    <div class="text" *ngIf="pageName == 'lgProfile'">      
      <span class="headText feedSlideCon">League Board</span>
    </div>
  </div>
  <div class="searchContainer" [ngClass]="{'active':showFeedSearch}" *ngIf="showFeedSearch">
    <div class="body">
      <div class="header">Search Fantasy Feed</div>
      <mat-form-field class="feedSearch">
        <input type="text" matInput placeholder="Search" [(ngModel)]="feedSearch" (keyup)="searchFeed($event)">
        <i class="fas fa-times reset" *ngIf="feedSearch != ''" (click)="feedSearch = ''; loadPosts();"></i>
      </mat-form-field>
      <div class="buttons">
        <button mat-button class="cancel" (click)="showFeedSearch = !showFeedSearch">Close</button>
      </div>
    </div>
  </div>
  <div class="blocker sameHeight" *ngIf="showPostbox || showLikeList || showFilters"
    (click)="showPostbox = false; showLikeList = false; showFilters = false;"></div>
  <div class="posts" *ngIf="showFeedCon" [@slideInOut] [@.disabled]="pageName=='lgProfile'" (scroll)="scrollPosts($event)" (click)="showLikeList = false;">
    <div class="post" *ngFor="let post of posts;let i = index;" [hidden]="post.hidden">
      <div class="pin" *ngIf="post.is_pin == 'Y'">
        <div class="text">Pinned Post<i class="fas fa-thumbtack" style="margin-left:5px;"></i></div>
      </div>
      <div class="left">
        <div class="body">
          <div class="picture" [ngStyle]="{'background-image':'url(\''+getUserImage(post)+'\')'}">
            <span class="startIcon_join" *ngIf="post.premium_star">
              <i class="starhover zmdi zmdi-star" tooltip="{{post.premium_star_msg}}" [options]="tooltipPly"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="post-type" *ngIf="pageName!='lgProfile'">
          <span class="news" *ngIf="post.feed_type == 'league_news'">
            News
          </span>
          <span class="legaue-post" *ngIf="post.feed_type == 'league_post'" (click)="leagueProfileRedirect(post.info)">
            League
          </span>
          <span class="community" *ngIf="!['league_news', 'league_post'].includes(post.feed_type)">
            Community
          </span>
        </div>
        <div class="body">
          <div class="top poll-{{post.poll_id}}">
            <div class="user"><span
                *ngIf="post.feed_type == 'league_news'">{{ (post.info != null && post.info != '' && post.info.name != null)?post.info.name:post.drafters_id }}</span><a
                [href]="profileLink(post.drafters_id)" *ngIf="post.feed_type != 'league_news'">{{post.drafters_id}}</a>
            </div>
            <span class="timestamp"> - {{getTimestamp(post.created)}}</span>
            <div class="myPost">
              <div class="myPostContent">
                <span *ngIf="post.feed_type == 'league_news'">
                  <b>{{post.title}}</b>
                </span>  
                <span *ngIf="!post.is_poll">
                  <div *ngIf="post.feed_type == 'league_news'">
                    <span class="showMore" (click)="post.analysis = !post.analysis">
                      <span>
                        <b>{{(post.analysis) ? ' Show Less' : ' Read More'}}</b>
                      </span>
                    </span>
                  </div>
                  <div *ngIf="post.feed_type != 'league_news'">
                    <span [innerHTML]="(post.expanded)?post.detail:(post.detail.length > 350)?post.detail.substr(0,350):post.detail"></span>
                    <span class="showMore" *ngIf="post.detail.length > 350" (click)="post.expanded = !post.expanded">
                      <span>
                        {{(post.expanded)?' ...Show Less':' ...Show More'}}
                      </span>
                    </span>
                  </div>
                  <div *ngIf="post.analysis">
                    <div>{{post.summary}}</div>
                    <div>{{post.detail}}</div>
                  </div>
                </span>
                <app-polls *ngIf="post.is_poll" [poll-id]="post.poll_id" [user]="user" (likeList)="pollLikeList($event)">
                </app-polls>
                <div class="gif" *ngIf="post.is_gif" [ngStyle]="{'background-image':'url(\''+post.gif+'\')'}"></div>
              </div>
              <div class="myPostTools" *ngIf="user.role_id == 1 || (user.id == post.user_id && post.feed_type != 'swap_post')">
                <div class="myPostDd">
                  <button mat-button [matMenuTriggerFor]="menupostdropdown">
                    <i class="zmdi zmdi-more-vert"></i>
                  </button>
                  <mat-menu panelClass="menu_dropdown" #menupostdropdown="matMenu">
                    <div class="myPostDdin">
                      <a *ngIf="user.role_id == 1 || (user.id == post.user_id && post.feed_type != 'swap_post')" mat-menu-item class="myPostDdList" href="javascript:void(0);"
                        (click)="confirmDialog({type : 'delete', postId : post.id, message : 'Are you sure you want to delete this post?', postIndex : i})">Delete</a>
                      <ng-container *ngIf="pageName!='lgProfile'">
                        <a mat-menu-item class="myPostDdList" href="javascript:void(0);"
                        (click)="confirmDialog({type : 'hide', postId : post.id, message : 'Are you sure you want to hide this post from your timeline?', postIndex : i})">Hide</a>
                        <a *ngIf="post.is_pin == 'N' && user.role_id == 1" mat-menu-item class="myPostDdList"
                          href="javascript:void(0);"
                          (click)="confirmDialog({type : 'pin', postId : post.id, message : 'Are you sure you want to pin this post?', postIndex : i})">Pin</a>
                        <a *ngIf="post.is_pin == 'Y' && user.role_id == 1" mat-menu-item class="myPostDdList"
                          href="javascript:void(0);"
                          (click)="confirmDialog({type : 'unpin', postId : post.id, message : 'Are you sure you want to remove pin from this post?', postIndex : i})">Remove
                          Pin</a>
                      </ng-container>
                    </div>
                  </mat-menu>
                </div>
              </div>
              <div style="clear: both;" *ngIf="!post.is_poll"></div>
            </div>
          </div>
          <div class="bottom">
            <div class="likes">
              <i class="fal fa-thumbs-up like" [ngClass]="{'active':post.is_like == 'yes'}"
                (click)="likePost(post)"></i>
              <div class="likeCount" (click)="postLikeList(post.id)">{{post.like_count}}</div>
            </div>
            <div class="comCounts" (click)="post.showComments = !post.showComments">
              <i class="fal fa-comment comIcon"></i>
              {{post.comments_count}}
            </div>
            <div class="pin2" *ngIf="post.is_pin == 'Y'">
              <div class="text">Pinned Post<i class="fas fa-thumbtack" style="margin-left:5px;"></i></div>
            </div>
          </div>
          <div class="rotowire-logo" *ngIf="post.feed_type == 'league_news'">
            <img src="{{rotowireLogo}}">
          </div>
        </div>
      </div>
      <div class="showMore" *ngIf="post.comments.length < post.comments_count && post.showComments"
        (click)="loadMoreComments(post)">
        View earlier comments...
      </div>
      <div class="comments" *ngIf="post.showComments">
        <div class="comment" *ngFor="let comment of post.comments; let j = index;">
          <div class="left">
            <div class="body">
              <div class="picture" [ngStyle]="{'background-image':'url(\''+getUserImage(comment)+'\')'}">
                <span class="startIcon_join" *ngIf="comment.premium_star">
                  <i class="starhover zmdi zmdi-star" tooltip="{{comment.premium_star_msg}}" [options]="tooltipPly"></i>
                </span>
              </div>
              <div class="timestamp">{{getTimestamp(comment.created)}}</div>
            </div>
          </div>
          <div class="right">
            <div class="body">
              <a *ngIf="user.role_id == 1 || user.id == comment.user_id" class="commentTrash" href="javascript:void(0);"
                (click)="confirmDialog({type : 'delete-comment', commentId : comment.id, message : 'Are you sure you want to delete this comment?', postIndex : i, commentIndex : j})"><i
                  class="fas fa-trash-o"></i></a>
              <div class="top">
                <div class="user">{{comment.drafters_id}}</div>
                <span>{{comment.comment}}</span>
                <div class="gifComment" *ngIf="comment.is_gif"
                  [ngStyle]="{'background-image':'url(\''+comment.gif+'\')'}"></div>
              </div>
              <div class="bottom">
                <div class="likes">
                  <i class="fal fa-thumbs-up like" [ngClass]="{'active':comment.is_like == 'yes'}"
                    (click)="likeComment(comment)"></i>
                  <div class="likeCount" (click)="commentLikeList(comment.id)">{{comment.like_count}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="userComment">
          <div class="left">
            <div class="body">
              <div class="picture" [ngStyle]="{'background-image':'url(\''+user.picture+'\')'}"></div>
            </div>
          </div>
          <div class="right">
            <div class="commentPlaceholder" (click)="postboxPost = post;postboxType = 'reply';showPostbox = true;">Leave
              a comment...</div>
          </div>
        </div>
      </div>
    </div>
    <div class="feed-empty" *ngIf="!isLoading && !posts.length && pageName == 'lgProfile'">
      <span>No league posts to show at this time.</span>
    </div>
    <mat-progress-bar *ngIf="isLoading" mode="buffer"></mat-progress-bar>
    <div id="post-add-btn" matTooltip="Create A Post" matTooltipPosition="below" (click)="showPostbox = true;postboxType = 'post';postboxPost = null;">
      <i class="fas fa-plus"></i>
    </div>
  </div>
  <button style="display:none;" mat-fab class="create" matTooltip="Create A Post" matTooltipPosition="above"
    (click)="showPostbox = true;postboxType = 'post';postboxPost = null;">
    <i class="fas fa-plus"></i>
  </button>
  <div class="postbox" *ngIf="showPostbox">
    <app-postbox [type]="postboxType" [post]="postboxPost" [user]="user"
      (close)="showPostbox = false;postboxClose($event)" lgId="{{lgId}}" tourId="{{tourId}}"></app-postbox>
  </div>
  <div class="likeList" *ngIf="showLikeList">
    <h1>{{likeList.header}}</h1>
    <perfect-scrollbar class="" [config]="config" style="max-height:280px; max-width: 100%;">
      <div class="likeRow" *ngFor="let like of likeList.list">
        {{like.drafters_id}}
      </div>
    </perfect-scrollbar>
  </div>
  <div class="filters" *ngIf="showFilters">
    <h1>Filters</h1>
    <mat-tab-group class="specialActive">
      <mat-tab label="Feeds">
        <ng-template matTabContent>
          <mat-selection-list [(ngModel)]="selectedFeeds" (selectionChange)="updateFeedFilters($event)" #filters>
            <mat-list-option *ngFor="let feed of feeds" class="feedOption" [value]="feed.value">{{feed.view}}
            </mat-list-option>
          </mat-selection-list>
        </ng-template>
      </mat-tab>
      <mat-tab label="News">
        <mat-selection-list [(ngModel)]="selectedGames">
          <div class="priorityText">
            <div class="priorityText-flex">
              <span class="text-small">Major news only</span>
              <span class="text-small">All news</span>
            </div>
            <div class="priorityText-img">
              <img [src]="bucketURL+'filter-arrow.svg'">
            </div>
          </div>
          <div *ngFor="let game of games" class="sportList">
            <mat-list-option [value]="game.name" [ngStyle]="{'color':'rgb('+game.color+')'}">
              <img matListAvatar [src]="bucketURL+game.name.toLowerCase()+'_icon.svg'" class="gameIcon">
              {{game.name}}
            </mat-list-option>
            <mat-slider thumbLabel color="primary" tickInterval="1" min="1" max="5" step="1"
              [(ngModel)]="gamePriorities[game.name]" class="filterSlider"></mat-slider>
          </div>
        </mat-selection-list>
      </mat-tab>
    </mat-tab-group>
    <div class="filterButtons">
      <button mat-button class="cancel" (click)="resetFilters()">Cancel</button>
      <button mat-button class="save" (click)="saveFilters()">Update</button>
    </div>
  </div>
</div>